import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from './supabaseClient';

export default function SignIn({ onAuth }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSignIn = async () => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    setMessage(error ? error.message : 'Logged in!');
    if (data?.user) {
      await supabase.from('users').upsert([
        {
          id: data.user.id,
          email: data.user.email,
        }
      ]);
      onAuth(data.user);
      navigate('/dashboard');
    }
  };

  return (
    <div>
      <h2>Sign In</h2>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input id="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" />
      </div>
      <div className="form-group">
        <label htmlFor="password">Password</label>
        <input id="password" value={password} onChange={e => setPassword(e.target.value)} type="password" placeholder="Password" />
        <div style={{ textAlign: 'right', marginTop: '4px' }}>
          <Link to="/reset-password" style={{ color: '#fff', fontSize: '0.9em', textDecoration: 'none' }}>
            Forgot Password?
          </Link>
        </div>
      </div>
      <button onClick={handleSignIn} style={{background:'transparent', color:'#fff', fontWeight:600, border:'1px solid #fff', borderRadius:6, padding:'10px 24px'}}>Sign In</button>
      <div className="message">{message}</div>
      <div style={{marginTop: 18, textAlign: 'center'}}>
        Don't have an account? <Link to="/signup" style={{color:'#fff'}}>Create one</Link>
      </div>
    </div>
  );
} 